import {
  getOrdinalDay,
  getCurrentMonth,
  getDayNumeric,
  getMonthShort,
  getYear,
  getDay,
  getMonth,
  getDayOfWeek,
  getNextMonth,
  niceDate,
} from '@/common/eventDateUtils';

export const eventDateMixin = {
  methods: {
    getOrdinalDay,
    getCurrentMonth,
    getDayNumeric,
    getMonthShort,
    getYear,
    getDay,
    getMonth,
    getDayOfWeek,
    getNextMonth,
    niceDate
  },
};
